import { ReactComponent as Icon } from "components/common/Icons/Progress/Pie/ThreeQuarterGreen/icon.svg";
interface Props {}

const ThreeQuarterGreen = (_: Props) => {
  return <Icon />;
};

export default ThreeQuarterGreen;
